/**
 * DeSight Shopify X | v1.0.0
 * Free Gift Module
 *
 * Automatically adds/removes a free gift product based on cart subtotal threshold.
 * Progress bar display is handled server-side via desight-cart-free-gift.liquid
 * and updated automatically by cart.js's section re-rendering.
 */
(function () {
  'use strict';

  var CONFIG = null;
  var PROCESSING = false;

  function init() {
    if (!window.DeSightFreeGift || !window.DeSightFreeGift.enabled) return;

    CONFIG = window.DeSightFreeGift;
    if (!CONFIG.giftVariantId || CONFIG.threshold == null) return;


    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
      return;
    }

    setInterval(checkAndSyncGift, 2000);
  }

  function onCartUpdate(data) {
    if (data && data.source === 'free-gift') return;
    checkAndSyncGift();
  }

  function getGiftItemFromCart(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === CONFIG.giftVariantId) {
        return cart.items[i];
      }
    }
    return null;
  }

  function calcNonGiftSubtotal(cart) {
    if (!cart || !cart.items) return 0;
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id !== CONFIG.giftVariantId) {
        total += cart.items[i].final_line_price || cart.items[i].line_price || 0;
      }
    }
    return total;
  }

  function checkAndSyncGift() {
    if (PROCESSING) return;
    PROCESSING = true;

    fetch(window.routes.cart_url + '.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var giftItem = getGiftItemFromCart(cart);
        var nonGiftSubtotal = calcNonGiftSubtotal(cart);
        var thresholdMet = nonGiftSubtotal >= CONFIG.threshold;

        if (thresholdMet && !giftItem) {
          return addGift();
        } else if (!thresholdMet && giftItem) {
          return removeGift(giftItem);
        }
        return Promise.resolve();
      })
      .catch(function (err) {
      })
      .finally(function () {
        PROCESSING = false;
      });
  }

  function addGift() {
    var formData = new FormData();
    formData.append('id', CONFIG.giftVariantId);
    formData.append('quantity', 1);
    formData.append('sections', 'cart-drawer,cart-icon-bubble,cart-live-region-text');
    formData.append('sections_url', window.location.pathname);

    return fetch(window.routes.cart_add_url + '.js', {
      method: 'POST',
      body: formData,
    })
      .then(function (res) {
        return res.text().then(function (text) {
          try { return JSON.parse(text); }
          catch (e) {
            return { status: 'error', description: 'Non-JSON' };
          }
        });
      })
      .then(function (data) {
        if (data.status === 422 || data.status === 'error') {
          return;
        }
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.classList.remove('is-empty');
        publishCartUpdate(data);
      });
  }

  function removeGift(giftItem) {
    var formData = new FormData();
    formData.append('id', giftItem.key);
    formData.append('quantity', 0);
    formData.append('sections', 'cart-drawer,cart-icon-bubble,cart-live-region-text');
    formData.append('sections_url', window.location.pathname);

    return fetch(window.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData,
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        renderEmptyState(data);
        publishCartUpdate(data);
      });
  }

  function renderEmptyState(data) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    var html = (data && data.sections && data.sections['cart-drawer']) || '';

    function applyEmptyState(htmlStr) {
      var parsed = new DOMParser().parseFromString(htmlStr, 'text/html');
      var sourceEmpty = parsed.querySelector('.drawer__inner-empty');
      if (!sourceEmpty) return;

      var liveEmpty = cartDrawer.querySelector('.drawer__inner-empty');
      var liveHeader = cartDrawer.querySelector('.drawer__header');

      if (liveEmpty) {
        liveEmpty.innerHTML = sourceEmpty.innerHTML;
      } else if (liveHeader) {
        liveEmpty = document.createElement('div');
        liveEmpty.className = sourceEmpty.className;
        liveEmpty.innerHTML = sourceEmpty.innerHTML;
        liveHeader.parentNode.insertBefore(liveEmpty, liveHeader);
      }

      cartDrawer.classList.add('is-empty');
    }

    if (html) {
      applyEmptyState(html);
    } else {
      fetch(window.routes.cart_url + '?section_id=cart-drawer')
        .then(function (res) { return res.text(); })
        .then(function (text) { applyEmptyState(text); });
    }
  }

  function publishCartUpdate(data) {
    if (typeof publish === 'function') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'free-gift',
        cartData: data
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
